export const MULTI_PRODUCT_ROUTES = {
    ECOMMERCE: "/miecommerce",
    RANKING: "/posicionamiento",
    POSITIONING: "/posicionamiento-beta",
    MANAGEMENT_SUMMARY: "/miresumengerencial",
    ASSORTMENT: "/assortment",
    MARKETPLACE: "/mimarketplace",
    PRODUCTOS: "/misproductos",
    CUSTOMER_REPORT: "/reporte-salud-clientes",
    MI_VISTA_MERCADO: "/mivistamercado",
};
